import React from 'react'
import { mergeClasses } from '@/helpers/styling'
import { SimpleTooltip } from '../simple-tooltip'
import { hasTextChild } from '@/utils/has-text-child'

export function Button(props: {
  variant?: "ghost" | "outline" | "primary" | "purple"
  title?: string
  className?: string
  children: React.ReactNode
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { title, variant, className, children, ...buttonProps } = props
  const isLabeled = hasTextChild(props.children)
  return (
    <SimpleTooltip tooltip={props.disabled ? "" : title} delayDuration={700}>
      <button
        type={props.type ?? "button"}
        disabled={props.disabled}
        className={mergeClasses(`
          flex flex-shrink items-center justify-center gap-2
          h-[30px] min-w-[30px] p-1 rounded-md
          font-medium text-[13px] font-exo select-none
          overflow-hidden text-ellipsis whitespace-nowrap
          active:translate-y-[1px] transition-translate`, {
            "!px-[10px]": isLabeled,
            "border !border-gray-400 !border-opacity-40 hover:bg-gray-200": variant === "outline",
            "hover:bg-gray-200": !props.disabled && variant === "outline",
            "bg-primary text-white hover:bg-primary/90": variant === "primary",
            "hover:bg-primary/90": !props.disabled && variant === "primary",
            "bg-[#51479e] text-white hover:bg-[#4e4497]": variant === "purple",
            "hover:bg-[#4e4497]": !props.disabled && variant === "purple",
            "hover:bg-stone-100": !props.disabled && variant === "ghost",
            "text-slate-700 hover:text-black": variant === "ghost",
            "opacity-50 cursor-default": props.disabled,
            "focus:!outline focus:!outline-1 focus:!outline-wistor-alt": !props.disabled && variant !== "ghost",
            "hover:bg-stone-100 focus:ring-2 active:bg-stone-200": !props.disabled && variant === "ghost"
          },
          className)}
        {...buttonProps}
      >
        {children}
      </button>
    </SimpleTooltip>
  )
}
